module.exports = __webpack_public_path__ + "static/media/loc6_img9.60470bc2.jpg";